import { SLICE_NAME } from './state';

const selector = {
    selectProductImgIndex: ({base: state}) => state[SLICE_NAME].productImgIndex,
    selectPayMethod: ({base: state}) => state[SLICE_NAME].payMethod,
    selectPayOption: ({base: state}) => state[SLICE_NAME].payOption,
    selectCouponCode: ({base: state}) => state[SLICE_NAME].couponCode,
}

export default selector